export const memberMatchesInviteSearch = (displayName: string, userId: string, searchTerm: string): boolean => {
  const lower = searchTerm.trim().toLowerCase();
  if (!lower) return true;
  return displayName.toLowerCase().includes(lower) || userId.toLowerCase().includes(lower);
};
